import { render, staticRenderFns } from "./ScheduledContentModalTrigger.vue?vue&type=template&id=f8963c32"
import script from "./ScheduledContentModalTrigger.vue?vue&type=script&lang=js"
export * from "./ScheduledContentModalTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports